export enum Paths {
  home = '/inicio',
  maps = '/mapa',
  orders = '/ordenes',
  deliveries = '/mantenimientos/delivery',
  stores = '/mantenimientos/sucursales',
  offers = '/mantenimientos/ofertas',
  login = '/auth/login'
}
